import {
  BaseEdge,
  BaseEdgeProps,
  type Edge as Edge_,
  EdgeLabelRenderer,
  type EdgeProps as EdgeProps_,
  getSmoothStepPath,
} from '@xyflow/react';

import { merge } from '../utils';
import { removeKeys } from '@/utils';

export type EdgeProps = {
  value?: number;
  variant?: 'success' | 'warning';
};

export type Edge = Edge_<EdgeProps, 'edge'>;

export const Edge = ({ id, sourceX, sourceY, targetX, targetY, label, data, ...rest }: EdgeProps_<Edge>) => {
  const [edgePath, labelX, labelY] = getSmoothStepPath({ sourceX, sourceY, targetX, targetY });

  const styles = [
    'edge-label-renderer__custom-edge',
    'nodrag',
    'nopan',
    'px-sm',
    'py-xs',
    'text-sm',
    'rounded-sm',
    'border-1',
    'w-fit',
  ];

  // eslint-disable-next-line
  const successStyles = [
    'border-success-300',
    'bg-success-25',
    'text-success-900',
  ];

  // eslint-disable-next-line
  const warningStyles = [
    'border-warning-300',
    'bg-warning-50',
    'text-warning-900',
  ];

  const baseEdgeProps = removeKeys(rest, [
    'selectable',
    'deletable',
    'sourcePosition',
    'targetPosition',
    'sourceHandleId',
    'targetHandleId',
    'pathOptions',
  ]) as Partial<BaseEdgeProps>;

  return (
    <>
      <BaseEdge id={id} path={edgePath} {...baseEdgeProps} />
      {label && (
        <EdgeLabelRenderer>
          <div
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            }}
            className={merge(
              styles,
              data?.variant === 'success' && successStyles,
              data?.variant === 'warning' && warningStyles
            )}
          >
            {label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};
